// extracted by mini-css-extract-plugin
module.exports = {"icon":"SmsWarningIcon_icon__N8Gmd"};